<p-card header="Edit Incident">
  <app-incident-form [incident]="incident()" (submit)="updateIncident($event)"></app-incident-form>
</p-card>
